module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/22.ecc8e31a.png";